import { deactivateTeamMember } from '@usehatchapp/javascript-sdk';

import { constants } from '../constants';

export const doDeactivateUser =
  ({ organizationId, userId } = {}) =>
  async ({ dispatch, request }) => {
    const {
      DEACTIVATE_USER_REQUEST,
      DEACTIVATE_USER_SUCCESS,
      DEACTIVATE_USER_FAILURE,
    } = constants;

    try {
      dispatch({ type: DEACTIVATE_USER_REQUEST });

      await request(deactivateTeamMember, { organizationId, userId });

      // set disabled to true in state
      dispatch({
        payload: { organizationId, userId },
        type: DEACTIVATE_USER_SUCCESS,
      });

      // dispatch notification saying we successfully deactivated user
      dispatch({
        actionCreator: 'doCreateNotificationMessage',
        args: [{ message: 'Successfully deactivated user.' }],
      });
    } catch (error) {
      dispatch({ error, type: DEACTIVATE_USER_FAILURE });
    }
  };
